import type { CustomerNavItem } from "@scott/ui-d2c/types";
import { useParams } from "next/navigation";
import type React from "react";
import { registrationAccessToDataLayer } from "@/utils/gtm.utils";

interface CustomerNavProps {
  navItems: CustomerNavItem[];
}

const CustomerNav: React.FC<CustomerNavProps> = ({ navItems }) => {
  const params = useParams();

  const handleGTM = (href?: string) => {
    if (href?.includes("/support/registration")) {
      registrationAccessToDataLayer(
        params.country ?? "",
        params.lang ?? "",
        "Navigation"
      );
    }
  };

  return (
    <ul className="pt-4 text-lg">
      {navItems
        .filter((item) => item.text && item.link)
        .map((item, index) => (
          <li
            className="m-0 p-2 font-bold"
            key={`customer-nav-${item.text}-${index}`}
          >
            <a
              href={item.link}
              onClick={(_e) => handleGTM(item.link)}
              rel={item.external ? "noopener noreferrer" : undefined}
              target={item.external ? "_blank" : "_self"}
            >
              {item.text}
            </a>
          </li>
        ))}
    </ul>
  );
};

export type { CustomerNavProps };
export { CustomerNav };
